import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Category from "@/pages/category/page";
import Article from "@/pages/article/page";
import ComicDetail from "@/pages/comic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/category/:slug",
    element: <Category />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "/comic/:slug",
    element: <ComicDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
